import React from 'react'
import Section from '../Section'
import { Row, Col } from 'components/Layout'
import Markdown from '../../../Markdown'
import CmsImg from 'features/Cms/Utils/CmsImg'
import { CarouselProvider, Slider, Slide, DotGroup } from 'pure-react-carousel'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import './Slider.global.scss'
import s from './Slider.scss'

export default class PickleSlider extends React.Component {
  render() {
    const props = {
      ...this.props,
      color: 'white',
      paddingTop: '2rem',
      paddingBottom: '2rem',
    }

    const settings = {
      naturalSlideWidth: 100,
      naturalSlideHeight: 40,
      totalSlides: props.items.length,
      infinite: true,
      isPlaying: true,
      isIntrinsicHeight: true,
    }

    return (
      <Section
        color={props.color}
        paddingTop={props.paddingTop}
        paddingBottom={props.paddingBottom}
      >
        <CarouselProvider {...settings}>
          <Slider>
            {props.items.map((item, idx) => (
              <Slide key={idx} index={idx}>
                <Row className={cn(sLay['layout-xs-column'], sLay['layout-gt-xs-row'])}>
                  <Col
                    className={cn(
                      sLay['layout-column'],
                      sLay['layout-align-center'],
                      sLay.flex,
                      sLay['flex-xs-100'],
                      sLay['flex-sm-100']
                    )}
                  >
                    <Markdown text={item.fields.text} />
                  </Col>

                  <Col
                    className={cn(
                      s.picture,
                      sLay['layout-column'],
                      sLay['layout-align-center-center'],
                      sLay.flex,
                      sLay['hide-xs']
                    )}
                  >
                    <CmsImg src={item.fields.image} />
                  </Col>
                </Row>
              </Slide>
            ))}
          </Slider>
          <DotGroup disableActiveDots={false} />
        </CarouselProvider>
      </Section>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Slider/Slider.jsx